import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=6076d04a&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=6076d04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076d04a",
  null
  
)

export default component.exports